module.exports = __webpack_public_path__ + "img/motor_no39.0b07a1ee.jpg";